import { blue, red, teal } from '@material-ui/core/colors';
import { React } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import manu from '../../../data/images/manu.png';
import { MoreButton, PaperTitle, PopularPaper, SectionBox, StyledBox, StyledColumn, StyledData, StyledHeading, StyledLogo, StyledParagraph, StyledPopular, StyledPopularGrid, StyledPopularGridItem, StyledRow, StyledStat } from '../../styles/global-style';


const PopularGames = () => {
    const dispatch = useDispatch()

    //   const [state, dispatch] = useReducer(reducer, initialState);

    const navigate = useNavigate();


    const handleMore = (data) => {
        console.log(data)
        dispatch({ type: 'Pass', payload: data })
        navigate('/Popular')
    }
    return (
        <SectionBox>
            <StyledBox align='justify'>
                <StyledHeading variant='h5'>Popular Games</StyledHeading>
                <StyledParagraph variant='caption'>
                    Under this section are <b>today's top matches</b> that we have analysed for you with sure predictions. To view complete predictions for these
                    games kindly subscribe to <b>VIP</b>. For more info on these matches, click the read more button.</StyledParagraph>
            </StyledBox>
            <StyledPopular>
                <StyledPopularGrid>
                    <StyledPopularGridItem item>
                        <PopularPaper>
                            <PaperTitle textcolor={'#121858'}>18 - 03 - 2022</PaperTitle>
                            <PaperTitle textcolor={teal[900]}>Man U Vs Everton</PaperTitle>
                            <StyledRow>
                                <StyledLogo component='img' alt='game logo' src={manu} />
                                <StyledColumn>
                                    <StyledData mcolor={red[900]}>20:30</StyledData>
                                    <StyledData mcolor={blue[700]}>EPL</StyledData>
                                </StyledColumn>
                                <StyledLogo component='img' alt='game logo' src={manu} />
                            </StyledRow>
                            <StyledRow>
                                <StyledColumn>
                                    <StyledStat>Home Win </StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                                <StyledColumn>
                                    <StyledStat>Draw</StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                                <StyledColumn>
                                    <StyledStat>Away Win </StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                            </StyledRow>
                            <MoreButton onClick={() => handleMore({ age: 10, height: 20 })} >Read More</MoreButton>

                        </PopularPaper>

                    </StyledPopularGridItem>
                    <StyledPopularGridItem item>
                        <PopularPaper>
                            <PaperTitle textcolor={'#121858'}>18 - 03 - 2022</PaperTitle>
                            <PaperTitle textcolor={teal[900]}>Man U Vs Everton</PaperTitle>
                            <StyledRow>
                                <StyledLogo component='img' alt='game logo' src={manu} />
                                <StyledColumn>
                                    <StyledData mcolor={red[900]}>20:30</StyledData>
                                    <StyledData mcolor={blue[700]}>EPL</StyledData>
                                </StyledColumn>
                                <StyledLogo component='img' alt='game logo' src={manu} />
                            </StyledRow>
                            <StyledRow>
                                <StyledColumn>
                                    <StyledStat>Home Win </StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                                <StyledColumn>
                                    <StyledStat>Draw</StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                                <StyledColumn>
                                    <StyledStat>Away Win </StyledStat>
                                    <StyledStat textcolor={red[900]}>50% </StyledStat>
                                </StyledColumn>
                            </StyledRow>
                            <MoreButton onClick={() => handleMore({ data: 'hey' })} >Read More</MoreButton>

                        </PopularPaper>

                    </StyledPopularGridItem>
                </StyledPopularGrid>
            </StyledPopular>
        </SectionBox>
    )
}

export default PopularGames